/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Error, GetRewardByIdV2Response, GetRewardsV2Response } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class V2<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Retrieves a reward catalog that includes variations within rewards
   *
   * @tags Rewards
   * @name CustomersRewardsDetail
   * @summary Retrieve the reward catalog with variations for a customer
   * @request GET:/v2/customers/{uuid}/rewards
   * @secure
   */
  customersRewardsDetail = (args: {
    uuid: string;
    query?: {
      /**
       * When true, returns all the variations that are restockable and the quanity is 0 or greater than 0
       * @default false
       */
      showRestockable?: boolean;
    };
    params?: RequestParams;
  }) =>
    this.request<GetRewardsV2Response, Error>({
      path: `/v2/customers/${args.uuid}/rewards`,
      method: 'GET',
      query: args.query,
      secure: true,
      format: 'json',
      ...args.params,
    });
  /**
   * @description Retrieves a specific reward for a customer with the ability to filter variations. Use showHidden=true to include disabled or zero quantity variations, or variationId to get a specific variation.
   *
   * @tags Rewards
   * @name CustomersRewardsDetail2
   * @summary Retrieve a specific reward for a customer with optional variation filtering
   * @request GET:/v2/customers/{uuid}/rewards/{rewardId}
   * @originalName customersRewardsDetail
   * @duplicate
   * @secure
   */
  customersRewardsDetail2 = (args: {
    uuid: string;
    rewardId: string;
    query?: {
      /**
       * When true, returns all reward variations including disabled or zero quantity ones
       * @default false
       */
      showHidden?: boolean;
      /** When specified, returns only the requested variation */
      variationId?: number;
    };
    params?: RequestParams;
  }) =>
    this.request<GetRewardByIdV2Response, Error>({
      path: `/v2/customers/${args.uuid}/rewards/${args.rewardId}`,
      method: 'GET',
      query: args.query,
      secure: true,
      format: 'json',
      ...args.params,
    });
}
